const menuCont = document.querySelector('.site-menu__cont')
const parent = document.querySelectorAll('.has-children > a')
const backButton = document.querySelectorAll('.mobile-buttons__back')
const mobileButton = document.querySelector('.mobile-button')

var dataLevel = 0
var menuOpen = false

function openParent() {
	var parentOpen = this.parentElement.classList.contains('open')
	const navigation = this.closest('.site-menu[data-level="1"]') || this.parentElement.querySelector('.site-menu[data-level="1"]')

	if (!parentOpen) {
		// Remove 'open' class from sibling elements
		let menuLevel = parseInt(this.parentElement.getAttribute('data-level'))
		const menuLevels = document.querySelectorAll('[data-level="'+menuLevel+'"]')

		menuLevels.forEach(function(el) {
			el.classList.remove('open')
			el.classList.remove('state')
			el.classList.remove('menu-open')

			// Close child items
			const menuItems = el.querySelectorAll('.has-children.open') 
			menuItems.forEach(function(el) {
				animateOut(el)
			});	
		});

		animateIn(this.parentElement)

		let navMinHeight = 0
		const visibleMenus = document.querySelectorAll('.menu-open > .site-menu')	
		if (navigation) {
			const navRectPrev = navigation.getBoundingClientRect()
			navigation.style.minHeight = ''
			visibleMenus.forEach(function(el) {
				const rect = el.getBoundingClientRect()
				if (rect.height >= navMinHeight) navMinHeight = rect.height
			})
			navigation.style.minHeight = navRectPrev.height + 'px'
			navigation.getBoundingClientRect()
			navigation.style.minHeight = navMinHeight + 'px'
		}
	} 
}

function closeNav() {
	dataLevel = 0
	const menuItems = document.querySelectorAll('.has-children.open') // select all open nav items
	menuItems.forEach(function(el) {
		animateOut(el)
	});
	closeMenu()
}

function dataCount() {
	dataLevel = dataLevel + 1
}

function backLevel() {
	// console.log(dataLevel)
	if (dataLevel === 0) {
		closeNav()
	} else {
		dataLevel = dataLevel - 1
		const menuTest = document.querySelectorAll('[data-level="'+dataLevel+'"]')

		console.log('test')
		// console.log(menuTest)
		menuTest.forEach(function(el) {
			// el.classList.remove('open')
			animateOut(el)
		});
	}
}

function toggleNav() {
	menuOpen ? closeMenu() : openMenu()
}

function openMenu() {
	menuOpen = true
	animateIn(menuCont)
}

function closeMenu() {
	menuOpen = false
	animateOut(menuCont)
}

// Event listeners
parent.forEach(function(el) {
	el.addEventListener('click', openParent);
	el.addEventListener('click', dataCount);
	el.addEventListener("click", function(event){
		event.preventDefault()
	});
});

backButton.forEach(function(el) {
	el.addEventListener('click', backLevel)
});

mobileButton.addEventListener('click', toggleNav)


// detect esc key
window.addEventListener('keydown', event => {
	const escKey = (event.key === 'Escape' || event.keyCode === 27)
	const isOpen = document.querySelector('.has-children.open') !== null
	if (escKey && isOpen) closeNav()
})



// Animation and timeotes

function animateIn(el) {
	el.classList.add('menu-open')
	el.classList.add('state')
	setTimeout(() => {
		el.classList.add('open') // display none
	}, 200); // transform - 100px
}

function animateOut(el) {
	el.classList.remove('menu-open')
	el.classList.remove('open') // display none
	setTimeout(() => {
		el.classList.remove('state')
	}, 200); // transform - 100px
}